
































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import ProfileMenu from './ProfileMenu.vue'
import TheMenuBasket from '../TheMenuBasket/TheMenuBasket'
import { profileColor, profileAbb } from '@/api/graphicIdentifier';

@Component({
    components: {
        TheMenuBasket,
        ProfileMenu
    }
})
export default class TheToolbarDesktop extends Vue {
    menu = false
    basket = false
    siteStatus = false
    profileColor = profileColor
    profileAbb = profileAbb
}
